/**
 * Constants for QuestionField component
 */

import { ICustomFormFieldTagSettings } from '@ViewModels';

export const QUESTION_TITLE_PREFIX = 'Question';

export const MODAL_HANDLER_TYPES = {
	CREATE_TAG: 'createTag',
	EDIT_TAG: 'editTag',
	CREATE_CUSTOM_FIELD: 'createCustomField',
	EDIT_CUSTOM_FIELD: 'editCustomField',
} as const;

export type ModalHandlerType = (typeof MODAL_HANDLER_TYPES)[keyof typeof MODAL_HANDLER_TYPES];

export const DEFAULT_TAG_GENERATION_SETTINGS = {
	tagOnCompletion: false,
	completionTag: '',
	customFormFieldTagSettings: [] as ICustomFormFieldTagSettings[],
};
